module.exports = __webpack_public_path__ + "img/bw.9f73f4f9.svg";